<div class="modal-header">
  <div class="divHeader">
    <h4 class="modal-title pull-left">{{title}}</h4>
    <span class="header">{{header}}</span>
  </div>
  <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
    <span style="font-weight: bold;" aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="container" id="comprovante-zeresima">
    <span class="title mb-3">Comprovante da Zerésima</span>
    <div class="row box_data">
      <div class="col-md-6">
        <label>Nome da Eleição: </label>
        <p>{{zeresimaData.tituloEleicao}}</p>
      </div>
      <div class="col-md-6">
        <label>IP Geração: </label>
        <p>{{zeresimaData.ipZeresima}}</p>
      </div>
    </div>
    <div class="row box_data">
      <div class="col-md-6">
        <label>Usuario: </label>
        <p>{{zeresimaData.nomeGestor}}</p>
      </div>
      <div class="col-md-6">
        <label>Data da geração da zerésima: </label>
        <p>{{zeresimaData.dataZeresima | date: 'dd/MM/yyyy HH:mm:ss'}}</p>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer divButtons">
  <button type="button" class="buttonConfirm btn" id="confirm" (click)="comprovantePDF()">Salvar comprovante</button>
</div>